var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBhd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.581,
    height: 18.497,
    viewBox: "0 0 25.581 18.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_23_Ensign_Flag_Nation_Bahrain_2634413",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3_",
    width: 24.581,
    height: 17.498,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3__-_Outline",
    "data-name": "XMLID_3_ - Outline",
    d: "M-.5-.5H25.081V18H-.5ZM24.081.5H.5V17H24.081Z",
    transform: "translate(0 0)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M131.6,106.7l3.331,1.746L131.6,110.2l3.331,1.752-3.331,1.746,3.331,1.752L131.6,117.2l3.331,1.746-3.331,1.752,3.331,1.752-3.331,1.746h16.983V106.7Z",
    transform: "translate(-124.002 -106.7)",
    fill: "#bd1f34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhd);
export default __webpack_public_path__ + "static/media/BHD.bea2c56fd4ea545167bf9a6c60a57688.svg";
export { ForwardRef as ReactComponent };